import { MDCRipple } from '@material/ripple'

export default {
  setup() {
    this.button = new MDCRipple(this.el)
  },
  destroy() {
    this.button?.destroy()
    this.button = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
